import type { MessageInstance } from "antd/es/message/interface";
import type { ReactNode } from "react";

const ToastMessage = (message: MessageInstance) => ({
  success: (content: string, duration: number = 5, icon?: ReactNode) =>
    icon
      ? message.open({ 
          type: "success", 
          content: <div style={{ marginLeft: 8 }}>{content}</div>, 
          duration, 
          icon 
        })
      : message.success(content, duration),
  error: (content: string, duration?: number, icon?: ReactNode) =>
    icon
      ? message.open({ 
          type: "error", 
          content: <div style={{ marginLeft: 8 }}>{content}</div>, 
          duration, 
          icon 
        })
      : message.error(content, duration),
  info: (content: string, duration?: number, icon?: ReactNode) =>
    icon
      ? message.open({ 
          type: "info", 
          content: <div style={{ marginLeft: 8 }}>{content}</div>, 
          duration, 
          icon 
        })
      : message.info(content, duration),
  warning: (content: string, duration?: number, icon?: ReactNode) =>
    icon
      ? message.open({ 
          type: "warning", 
          content: <div style={{ marginLeft: 8 }}>{content}</div>, 
          duration, 
          icon 
        })
      : message.warning(content, duration),
  loading: (content: string, duration?: number, icon?: ReactNode) =>
    icon
      ? message.open({ 
          type: "loading", 
          content: <div style={{ marginLeft: 8 }}>{content}</div>, 
          duration, 
          icon 
        })
      : message.loading(content, duration),
  destroy: () => message.destroy(),
});

export default ToastMessage;
